import {FixedSizeList} from "react-window";
import React from "react";
import AutoSizer from "react-virtualized-auto-sizer";
import InfiniteLoader from "react-window-infinite-loader";

export const LazyLoadedList = ({
                                   itemCount,
                                   loadMoreItems,
                                   item,
                                   itemSize,
                                   isItemLoaded
                               }: any) => {
    return (
        <AutoSizer>
            {({
                  height,
                  width
              }: any) => (
                <InfiniteLoader
                    itemCount={itemCount}
                    loadMoreItems={loadMoreItems}
                    isItemLoaded={isItemLoaded}
                >
                    {({
                          onItemsRendered,
                          ref
                      }: any) => <FixedSizeList
                        itemCount={itemCount}
                        ref={ref}
                        height={height}
                        itemSize={itemSize}
                        width={width}
                        onItemsRendered={onItemsRendered}
                    >
                        {item}
                    </FixedSizeList>}
                </InfiniteLoader>
            )}
        </AutoSizer>
    );
}
